import { cva as e } from "class-variance-authority";
// src/design/card/styles.ts
var t = e("rounded-lg transition-all duration-normal", {
	variants: {
		variant: {
			elevated: "bg-card shadow-md hover:shadow-lg",
			outlined: "bg-card border border-border",
			filled: "bg-muted border-0",
			interactive: "bg-card border border-border hover:shadow-md cursor-pointer",
			ghost: "bg-transparent border-0"
		},
		size: {
			none: "p-0",
			sm: "p-3",
			md: "p-4",
			lg: "p-6",
			xl: "p-8"
		}
	},
	defaultVariants: {
		variant: "outlined",
		size: "md"
	}
}), n = e("flex items-start justify-between", {
	variants: {
		spacing: {
			none: "",
			sm: "mb-2",
			md: "mb-4",
			lg: "mb-6"
		},
		bordered: {
			true: "border-b border-border pb-4",
			false: ""
		}
	},
	defaultVariants: {
		spacing: "md",
		bordered: !1
	}
}), r = e("font-semibold text-foreground", {
	variants: { size: {
		sm: "text-sm",
		md: "text-base",
		lg: "text-md",
		xl: "text-lg"
	} },
	defaultVariants: { size: "md" }
}), i = e("text-muted-foreground", {
	variants: { size: {
		sm: "text-xs",
		md: "text-sm",
		lg: "text-base"
	} },
	defaultVariants: { size: "md" }
}), a = e("text-foreground", {
	variants: {
		spacing: {
			none: "",
			sm: "space-y-2",
			md: "space-y-3",
			lg: "space-y-4"
		},
		size: {
			sm: "text-xs",
			md: "text-sm",
			lg: "text-base"
		}
	},
	defaultVariants: {
		spacing: "md",
		size: "md"
	}
}), o = e("flex items-center", {
	variants: {
		spacing: {
			none: "",
			sm: "mt-2",
			md: "mt-4",
			lg: "mt-6"
		},
		bordered: {
			true: "border-t border-border pt-4",
			false: ""
		},
		justify: {
			start: "justify-start",
			center: "justify-center",
			end: "justify-end",
			between: "justify-between"
		}
	},
	defaultVariants: {
		spacing: "md",
		bordered: !1,
		justify: "end"
	}
}), s = e("w-full object-cover", {
	variants: {
		position: {
			top: "rounded-t-lg",
			bottom: "rounded-b-lg",
			full: "rounded-lg"
		},
		aspectRatio: {
			auto: "aspect-auto",
			square: "aspect-square",
			video: "aspect-video",
			"4/3": "aspect-[4/3]",
			"3/2": "aspect-[3/2]"
		}
	},
	defaultVariants: {
		position: "top",
		aspectRatio: "auto"
	}
});
export { a as cardBody, i as cardDescription, o as cardFooter, n as cardHeader, s as cardImage, t as cardRoot, r as cardTitle };

//# sourceMappingURL=styles.js.map